import { useMemo, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { pdf } from "@react-pdf/renderer";
import InvoiceDocument from "./InvoiceDocument";
import { useForm } from "react-hook-form";

const Invoice = ({
  company = {
    name: "Freight Network Name",
    address: "Freight Network Address",
    phone: "123 456-7890",
    web: "https://www.freightnetwork.com",
    email: "Network@example.com",
    logo: "/assets/images/logo-icon.png",
  },
  customer = {
    name: "Company Name",
    address: "Company Address",
    email: "john@example.com",
    ContactPerson: "Key Contact Name",
    phone: "123 456-7890",
  },
  invoice = {
    id: "FN-2025-001",
    date: "01/10/2018",
    dueDate: "30/10/2018",
    Currency: "USD",
  },
  items = [
    {
      no: 1,
      title: "Annual Network Membership Fee",
      details: "2025",
      qty: 1,
      unitPrice: 5000.0,
    },
    {
      no: 2,
      title: "Event Registration (Global Conference)",
      details: "Location, Date",
      qty: 1,
      unitPrice: 500.0,
    },
    {
      no: 3,
      title: "Marketing Support & Directory Listing",
      details: "12 Months",
      qty: 1,
      unitPrice: 200.0,
    },
    {
      no: 4,
      title: "Transaction Handling Fees",
      details: "5 Shipments",
      qty: 5,
      unitPrice: 5.0,
    },
  ],
  payment = {
    bankName: "Freight Network Bank Name",
    accountName: "Freight Network Name",
    accountNumber: "123456789",
    swiftCode: "ABCDXYZ",
    terms: "Net 30 Days",
    reference: "Please quote your Invoice No in all payments",
  },
  notes = [
    "This invoice is issued for Freight Network services only and does not cover third-party logistics or freight charges.",
    "Late payments may incur additional fees as per the network's policy.",
  ],
  taxRate = 0.25, // 25%
}) => {
  const componentRef = useRef(null);

  const { subTotal, tax, grandTotal } = useMemo(() => {
    const sub = items.reduce((sum, it) => sum + it.unit * it.qty, 0);
    const tx = sub * taxRate;
    return {
      subTotal: sub,
      tax: tx,
      grandTotal: sub + tx,
    };
  }, [items, taxRate]);

  const money = (n) =>
    n.toLocaleString(undefined, { style: "currency", currency: "USD" });

  const handlePrint = async () => {
  const blob = await pdf(
    <InvoiceDocument
      company={company}
      customer={customer}
      invoice={invoice}
      items={items}
      taxRate={taxRate}
      payment={payment}
      notes={notes}
    />
  ).toBlob();

  const blobURL = URL.createObjectURL(blob);
  const printWindow = window.open(blobURL);
  printWindow.onload = () => {
    printWindow.print();
  };
};

  const {register,handleSubmit} = useForm();

   const onClick = (data) =>{
    console.log("Form submitted with data:", data);
   }

  return (
    <div className="page-content">
      {/* Breadcrumb (optional) */}
      <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <div className="breadcrumb-title pe-3">Applications</div>
      </div>

      {/* Card */}
      <div className="card">
        <div className="card-body">
          <div id="invoice">
            {/* Toolbar */}
            <div className="toolbar hidden-print">
              <div className="text-end">
                <button type="button" className="btn btn-dark me-2" onClick={handlePrint}>
                  <i className="fa fa-print" /> Print
                </button>
              </div>
              <hr />
            </div>

            {/* Printable area */}
            <div className="invoice overflow-auto">
              <div style={{ minWidth: 600 }} ref={componentRef}>
                <header>
                  <div className="row">
                    <div className="col">
                      <a href="#">
                        <img src={company.logo} width="80" alt="logo" />
                      </a>
                    </div>
                    <div className="col company-details">
                      <h4 className="name mb-1">
                        {company.name}
                      </h4>
                      <div> <strong>Address:</strong> {company.address}</div>
                      <div><strong>Email:</strong>{company.email}</div>
                      <div><strong>Phone:</strong>{company.phone}</div>
                      <div className="ablue"><strong>Website:</strong>{" "}
                        <a href={company.web} target="_blank" rel="noopener noreferrer">
                          {company.web}
                        </a></div>
                    </div>
                  </div>
                </header>
                <hr />
                <main>
                  <div className="row contacts">
                    <div className="col invoice-to">
                      <div className="text-gray-light"><strong>Bill TO:</strong></div>
                      <div className="to">{customer.name}</div>
                      <div className="ContactPerson"><strong>Contact Person:</strong>{customer.ContactPerson}</div>
                      <div className="address"><strong>Address:</strong>{customer.address}</div>
                      <div className="phone"><strong>Phone:</strong>{customer.phone}</div>
                      <div className="email ablue"><strong>Email:</strong>
                        <a href={`mailto:${customer.email}`}>{customer.email}</a>
                      </div>
                    </div>
                    <div className="col invoice-details">
                      <div className=""><strong>Invoice No:</strong>{invoice.id}</div>
                      <div className="date"><strong>Date:</strong> {invoice.date}</div>
                      <div className="date"><strong>Due Date:</strong> {invoice.dueDate}</div>
                      <div className="date"><strong>Currency:</strong> {invoice.Currency}</div>
                    </div>
                  </div>

                  <table className="table table-bordered ">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Description of Charges</th>
                        <th>Details</th>
                        <th>Qty</th>
                        <th>Unit Price</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.no}</td>
                          <td>{item.title}</td>
                          <td>{item.details}</td>
                          <td>{item.qty}</td>
                          <td>{item.unitPrice.toFixed(2)}</td>
                          <td>{(item.unitPrice * item.qty).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={5} className="text-end"><strong>Subtotal</strong></td>
                        <td>
                          {items
                            .reduce((sum, i) => sum + i.unitPrice * i.qty, 0)
                            .toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={5} className="text-end"><strong>Taxes (25%)</strong></td>
                        <td>
                          {(items.reduce((sum, i) => sum + i.unitPrice * i.qty, 0) * 0.25).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={5} className="text-end"><strong>Total Amount Due:</strong></td>
                        <td>
                          {(items.reduce((sum, i) => sum + i.unitPrice * i.qty, 0) * 1.25).toFixed(2)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </main>
                <div className="payment-instructions mt-0 mb-0">
                  <h5><strong>Payment Instructions:</strong></h5>
                  <p><strong>Bank Name:</strong> {payment.bankName}</p>
                  <p><strong>Account Name:</strong> {payment.accountName}</p>
                  <p><strong>Account Number/IBAN:</strong> {payment.accountNumber}</p>
                  <p><strong>SWIFT/BIC Code:</strong> {payment.swiftCode}</p>
                  <p><strong>Payment Terms:</strong> {payment.terms}</p>
                  <p><strong>Reference:</strong> {payment.reference}</p>
                </div>
                <div className="invoice-notes mt-4 border-top pt-3">
                  <h6><strong>Notes:</strong></h6>
                  <ul>
                    {notes.map((note, idx) => (
                      <li key={idx}>{note}</li>
                    ))}
                  </ul>
                </div>


                <footer>
                  Invoice was created on a computer and is valid without the signature and seal.
                </footer>
              </div>

              {/* DO NOT DELETE: keeps footer at bottom */}
              <div />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
